import React from 'react';
import { Container, Row, Col, ListGroup } from 'react-bootstrap';

function Contact() {
  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col md={8}>
          <h1 className="text-center mb-4">Свяжитесь с нами</h1>
          <p className="text-center text-muted mb-5">
            Мы всегда рады ответить на ваши вопросы. Вы можете связаться с нами любым удобным для вас способом.
          </p>
          <ListGroup variant="flush">
            <ListGroup.Item className="d-flex align-items-center">
              <span role="img" aria-label="phone" className="me-3 fs-4">📞</span>
              <div>
                <strong>Телефон:</strong> <a href="tel:+358417587654">+358 41 758 7654</a>
              </div>
            </ListGroup.Item>
            <ListGroup.Item className="d-flex align-items-center">
              <span role="img" aria-label="email" className="me-3 fs-4">📧</span>
              <div>
                <strong>Email:</strong> <a href="mailto:krayonika.art@gmail.com">krayonika.art@gmail.com</a>
              </div>
            </ListGroup.Item>
            <ListGroup.Item className="d-flex align-items-center">
              <span role="img" aria-label="facebook" className="me-3 fs-4">👍</span>
              <div>
                <strong>Facebook:</strong> <a href="https://www.facebook.com/profile.php?id=61579794297971" target="_blank" rel="noopener noreferrer">Krayonika Art</a>
              </div>
            </ListGroup.Item>
            <ListGroup.Item className="d-flex align-items-center">
              <span role="img" aria-label="instagram" className="me-3 fs-4">📸</span>
              <div>
                <strong>Instagram:</strong> <a href="https://www.instagram.com/krayonika" target="_blank" rel="noopener noreferrer">@krayonika</a>
              </div>
            </ListGroup.Item>
            <ListGroup.Item className="d-flex align-items-center">
              <span role="img" aria-label="telegram" className="me-3 fs-4">✈️</span>
              <div>
                <strong>Telegram:</strong> <a href="https://t.me/KRAYONIKA" target="_blank" rel="noopener noreferrer">@KRAYONIKA</a>
              </div>
            </ListGroup.Item>
          </ListGroup>
        </Col>
      </Row>
    </Container>
  );
}

export default Contact;